import { useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function useFeatureDesktopAnimation({ setCurrentSection }) {
  useEffect(() => {
    const sections = gsap.utils.toArray('.feature-item')

    sections.forEach((section, index) => {
      gsap.to(section, {
        scrollTrigger: {
          start: 'top 60%',
          end: 'bottom 60%',
          trigger: section,
          onEnter: () => {
            setCurrentSection(index)
          },
          onEnterBack: () => {
            setCurrentSection(index)
          },
        },
      })
    })

    const tl = gsap.timeline()

    tl.to('.fixed', {
      opacity: 1,
      scrollTrigger: {
        trigger: '.fixed',
        pin: true,
        start: 'top 88px',
        end: 'bottom 70%',
        pinSpacing: false,
      },
    })
    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill())
    }
  }, [setCurrentSection])
}
